import { z } from "zod";

/**
 * Opcionális szám űrlapról: az üres mező (`""` vagy `null`) üres marad, nem lesz belőle 0.
 * A `z.coerce.number()` önmagában a `null`-ból és az üres szövegből 0-t csinálna – egy üresen
 * hagyott plafonból így „legfeljebb 0%” lett. A `undefined` (nem küldött mező) érintetlen marad.
 */
export const optNum = <T extends z.ZodTypeAny>(schema: T) => z.preprocess((v) => (v === "" || (typeof v === "string" && v.trim() === "") ? null : v), schema.nullable()).optional();
